// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Merriweather Sans', 'Merriweather Sans Fallback'","fontStyle":"normal"},"className":"__className_ee2f0d","variable":"__variable_ee2f0d"};